export function requireEnv(key: string, devFallback?: string): string {
  const value = import.meta.env[key] as string | undefined;
  if (value) return value;

  if (import.meta.env.DEV && devFallback !== undefined) {
    return devFallback;
  }

  throw new Error(
    `[env] Required environment variable ${key} is not set. ` +
    `Create admin/.env.local with ${key}=<value>.`
  );
}

export const ENV = {
  ADMIN_BFF_URL: requireEnv("VITE_ADMIN_BFF_URL", "http://localhost:3000"),
  SUPABASE_URL: requireEnv("VITE_SUPABASE_URL"),
  SUPABASE_ANON_KEY: requireEnv("VITE_SUPABASE_ANON_KEY"),
} as const;
